export enum Environment {
  Localhost = 'localhost',
  Dev = 'dev',
  QA = 'qa',
  Stage = 'stage',
  Production = 'production',
}

export interface EnvironmentConfig {
  environment: Environment;
  isLocalhost: boolean;
  isDev: boolean;
  isQa: boolean;
  isStage: boolean;
  isProduction: boolean;
  supabaseUrl: string;
  supabasePublishableKey: string;
  clerkPublishableKey: string;
}
